import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parentContainer: {
        width: 566,
        margin: '15px 0 15px 15px',
    },
    defaultDelivery: {
        marginBottom: 10
    },
    gridContainer: {
        width: 550,
    },
    grid: {
        height: 410,
        width: 550,
    },
});
